/* global FB */

import React, { useState, useEffect } from "react";
import Navbar from "../../Components/Common/Navbar";
import Footer from "../../Components/Common/Footer";
import {
  Box,
  Typography,
  TextField,
  InputLabel,
  Checkbox,
  Button,
  Divider,
  InputAdornment,
  IconButton,
} from "@mui/material";
import Newsletter from "../../Components/Common/Newsletter";
import { Link, useLocation, useNavigate } from "react-router-dom";
import googleImg from "../../assets/Icons/googs.svg";
import facebook from "../../assets/Icons/Facebook.svg";
import apple from "../../assets/Icons/bi_apple.svg";
import { useSelector, useDispatch } from "react-redux";
import { setUser, setUserEmail, setUserId } from "../../store/userSlice";
import FacebookLogin from "@greatsumini/react-facebook-login";
import {
  LOGIN_MUTATION,
  RESEND_OTP,
  SIGNIN_SOCIAL,
} from "../../Utils/Mutations";
import { useMutation } from "@apollo/client";
import { resetSocket } from "../../Utils/socket";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { LoadingButton } from "@mui/lab";
import SaveIcon from "@mui/icons-material/Save";
import Loader from "../../Components/Common/Loader";
import "./login.css";
import { useSnackbar } from "notistack";
import { signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { auth } from "../../Utils/FirebaseConfig";
import Modal from "@mui/material/Modal";
import not from "../../assets/no.png";
import MaButton from "../../Components/UI/ma-button";
import useAuthFlow from "../../Hooks/use-auth-flow";
import { IoClose } from "react-icons/io5";
import MaInput from "../../Components/UI/ma-input";

const style = {
  position: "absolute",
  top: "20%",
  left: { lg: "70%", md: "65%", sm: "50%", xs: "50%" },
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "transparent",

  p: 4,
};

const LoginForm = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // =========ALERT FUNCTIONS =============================================================================================================
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (variant, message) => () => {
    enqueueSnackbar(message, { variant });
  };
  // ================================================

  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);

  const [email, setEmail] = useState("");

  const [password, setPassword] = useState("");

  const [showPassword, setShowPassword] = React.useState(false);

  const [accessToken, setAccessToken] = useState(null);
  const lastLoginMethod = localStorage.getItem("lastLoginMethod") || "email"; // "email" | "google"

  const isInFlorida = JSON.parse(localStorage.getItem("isInFlorida"));

  const dispatch = useDispatch();

  const locationState = location.state;
    const { switchAuth, onClose } = useAuthFlow();

  const from = location.state?.from?.pathname || "/";

  // =========MUTATIONS===============================================================================================================
  const [loginMutation, { loading, error }] = useMutation(LOGIN_MUTATION);
  const [googleAuth, { loading: googleLoader }] = useMutation(SIGNIN_SOCIAL);
  const [resendOtpMutation, { loading: resendLoading, error: resendError }] =
    useMutation(RESEND_OTP);

  // =======================================

  // ======= FIREBASE GOOGLE LOGIN (in-app popup) ======================================================================================================
  const loginGoogle = async () => {
    try {
      const provider = new GoogleAuthProvider();
      
      const result = await signInWithPopup(auth, provider);
      const credential = GoogleAuthProvider.credentialFromResult(result);
      const token = credential?.accessToken;
      if (token) setAccessToken(token);
    } catch (err) {
      console.error(err);
      handleClickVariant("error", err?.message || "Google sign-in failed.");
    }
  };

  useEffect(() => {
    if (accessToken) {
      handleGoogleSignIn();
    }
  }, [accessToken]);

  const handleGoogleSignIn = async () => {
    try {
      const { data } = await googleAuth({
        variables: {
          accessToken: accessToken || "",
          socialAuthProviderKey: "GOOGLE_AUTH",
          useAccessToken: true,
        },
      });

      if (data?.loginThroughSocialAuth?.message === "Login succeeded") {
        localStorage.setItem("lastLoginMethod", "google");
        resetSocket();
        onClose()
        dispatch(setUser(data?.loginThroughSocialAuth));
        localStorage.setItem("isAuthenticated", "true");
        localStorage.setItem(
          "mamaketUserToken",
          data?.loginThroughSocialAuth?.accessToken,
        );
        localStorage.setItem(
          "tokenExpiresIn",
          data?.loginThroughSocialAuth?.tokenExpiresIn,
        );
        // navigate(from, { replace: true });
        // if (locationState && locationState.redirectTo) {
        //   navigate(`${locationState?.redirectTo}`);
        // } else {
        //   navigate("/");
        // }
      } else if (data?.loginThroughSocialAuth.message === "VERIFY_OTP") {
        navigate("/verify");
        dispatch(setUserEmail(email));
        ResendOtp();
      } else if (
        data?.loginThroughSocialAuth.message === "CREATE_TRANSACTION_PIN"
      ) {
        dispatch(setUserId(data?.loginThroughSocialAuth?.data));
        navigate("/createpin");
      }
    } catch (error) {
      handleClickVariant(
        "error",
        "Your account is not yet registered. Please sign up instead.",
      );
      navigate("/register");
      console.error(error);
    }
  };

  // ======= HANDLE EMAIL & PASSWORD LOGIN ========================================================================================================

  const handleLogin = async () => {
    try {
      const { data } = await loginMutation({
        variables: { email, password },
      });

      if (data?.loginUser?.message === "Login succeeded") {
        localStorage.setItem("lastLoginMethod", "email");
        resetSocket();
        onClose()
        dispatch(setUser(data?.loginUser));
        localStorage.setItem("isAuthenticated", "true");
        localStorage.setItem("mamaketUserToken", data?.loginUser?.accessToken);
        localStorage.setItem("tokenExpiresIn", data?.loginUser?.tokenExpiresIn);
        // navigate(from, { replace: true });
        // if (locationState && locationState.redirectTo) {
        //   navigate(`${locationState?.redirectTo}`);
        // } else {
        //   navigate("/");
        // }
      } else if (data?.loginUser.message === "VERIFY_OTP") {
        navigate("/verify");
        dispatch(setUserEmail(email));
        ResendOtp();
      } else if (data?.loginUser.message === "CREATE_TRANSACTION_PIN") {
        dispatch(setUserEmail(email));
        dispatch(setUserId(data?.loginUser?.data));
        navigate("/createpin");
      }
    } catch (error) {
      const message =
        error?.message ?? error?.graphQLErrors?.[0]?.message ?? "";
      if (
        typeof message === "string" &&
        message.toLowerCase().includes("kindly login through google")
      ) {
        loginGoogle();
      }
      console.error(error);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleLogin();
    }
  };

  const ResendOtp = async () => {
    try {
      const { data } = await resendOtpMutation({
        variables: { email: email },
      });

      dispatch(setUserId(data?.resendOTP?.uuid));
    } catch (error) {
      console.error("Error resending OTP:", error);
    }
  };

  useEffect(() => {
    if (isInFlorida === null) {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    if (isInFlorida === false) {
      handleOpen();
    }
  }, [isInFlorida]);


  return (
    <>
      {resendLoading && <Loader />}
      <Box sx={{ bgcolor: "#F8",  pb:{md:0, xs:5},   borderRadius: {md:"20px", xs:'0px'}, width: {md:470, xs:"100vw"} }}>
        <Box
          sx={{
            margin: "0 auto",

            bgcolor: "#fff",
            borderRadius: {md:"20px", xs:'0px'},
            px: {md:5, xs:2},
            py: 3,
          }}
        >
          <div className="flex items-center justify-between">
            <div>
              <Typography
                sx={{ color: "#1a1a1a", fontWeight: 600, fontSize: "20px" }}
              >
                Welcome back
              </Typography>
              <Typography
                sx={{ color: "#666", fontWeight: 400, fontSize: "14px" }}
              >
                Please enter your detail
              </Typography>
            </div>
            <div>
              <IconButton onClick={() => onClose()}>
                <IoClose className="text-black" />
              </IconButton>
            </div>
          </div>

          <Box sx={{ mt: 4 }}>
            {lastLoginMethod === "google" && (
              <Box align="center" sx={{}}>
                {googleLoader ? (
                  <LoadingButton
                    disabled
                    loading
                    loadingPosition="start"
                    startIcon={<SaveIcon />}
                    sx={{
                      bgcolor: "#F8F7F7",
                      color: "#1a1a1a",
                      fontWeight: 400,
                      fontSize: "14px",
                      py: 2,
                      borderRadius: "50px",
                    }}
                    fullWidth
                  >
                    <img src={googleImg} style={{ marginRight: "10px" }} />
                    Signing in with Google
                  </LoadingButton>
                ) : (
                  <>
                    <Button
                      className="button"
                      variant="contained"
                      disabled={!isInFlorida}
                      onClick={loginGoogle}
                      sx={{
                        color: "#fff",
                        fontWeight: 400,
                        fontSize: "14px",
                        py: 2,
                        height: "46px",
                        borderRadius: "50px",
                      }}
                      fullWidth
                    >
                      <img src={googleImg} style={{ marginRight: "10px" }} />
                      Continue with Google
                    </Button>
                    {lastLoginMethod && (
                      <div className="flex justify-start pl-7">
                        <Typography
                          sx={{
                            position: "relative",
                            top: "-65px",
                            color: "#7B408C",
                            fontWeight: 500,
                            fontSize: "10px",
                            border: "1px solid #7B408C",
                            bgcolor: "#fff",
                            width: "fit-content",
                            margin: "10px",
                            padding: "0px 15px",
                            borderRadius: "50px",
                          }}
                        >
                          Last sign-in: Google
                        </Typography>
                      </div>
                    )}
                  </>
                )}
                <Divider sx={{ mb: 2 }}>
                  <Typography>OR</Typography>
                </Divider>
              </Box>
            )}
            <form onSubmit={handleLogin}>
              <div>
                <MaInput
                  fullWidth
                  label="Email"
                  placeholder="Email Address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="mt-4">
                <MaInput
                  fullWidth
                  label="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter Password"
                   type={showPassword ? "text" : "password"}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword(!showPassword)}
                          edge="end"
                        >
                          {showPassword ? (
                            <VisibilityOutlinedIcon sx={{ fontSize: "16px" }} />
                          ) : (
                            <VisibilityOffOutlinedIcon
                              sx={{ fontSize: "16px" }}
                            />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
         

         
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", ml: -1 }}>
                <Checkbox />{" "}
                <Typography sx={{ fontSize: "13px", color: "#333" }}>
                  Remember me
                </Typography>
              </Box>
              <Link
                to="/forget_password"
                style={{
                  textDecoration: "none",

                  fontWeight: 400,
                  fontSize: "13px",
                  color: "#333",
                }}
              >
                Forgot password?
              </Link>
            </Box>

            {error && (
              <Typography
                sx={{
                  color: "#ff0000",
                  textAlign: "center",
                  bgcolor: "#ff00001a",
                  border: "0.5px solid red",
                  borderRadius: "50px",
                  width: "fit-content",
                  margin: "10px auto",
                  padding: "5px 15px",

                  fontSize: "12px",
                }}
              >
                {error.message}
              </Typography>
            )}

            <MaButton
            type="button"
              onClick={handleLogin}
              disabled={!isInFlorida}
              variant={"primary"}
              fullWidth
              title="Sign In"
              loading={loading}
              sx={{ mt: 3, bgcolor: "#272727", borderRadius: "50px" }}
            />
            </form>

            <Typography
              sx={{
                textAlign: "center",
                mt: 1,
                fontSize: "13px",
                color: "#666",
              }}
            >
              New to Mamaket?{" "}
              <span
                onClick={() => switchAuth("signup")}
                className="text-primary font-bold text-[13px] cursor-pointer"
              >
                Sign up
              </span>
            </Typography>

            {lastLoginMethod === "email" && (
              <>
                <Divider sx={{ mt: 3 }}>
                  <Typography>OR</Typography>
                </Divider>

                <Box align="center" sx={{ mt: 3 }}>
                  {googleLoader ? (
                    <LoadingButton
                      disabled
                      loading
                      loadingPosition="start"
                      startIcon={<SaveIcon />}
                      sx={{
                        bgcolor: "#F8F7F7",
                        color: "#1a1a1a",
                        fontWeight: 400,
                        fontSize: "14px",
                        py: 2,
                        borderRadius: "50px",
                        height:'46px'
                      }}
                      fullWidth
                    >
                      <img src={googleImg} style={{ marginRight: "10px" }} />
                      Signing in with Google
                    </LoadingButton>
                  ) : (
                    <Button
                      disabled={!isInFlorida}
                      onClick={loginGoogle}
                      className="button"
                      sx={{
                        bgcolor: "#5d3068",
                        color: "#fff",
                        fontWeight: 400,
                        fontSize: "14px",
                        py: 2,
                        borderRadius: "50px",
                        height:'46px'
                      }}
                      fullWidth
                    >
                      <img src={googleImg} style={{ marginRight: "10px" }} />
                      Sign in with Google
                    </Button>
                  )}
                </Box>
              </>
            )}
          </Box>
        </Box>
      </Box>

      <Modal
        open={open}
        // onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                boxShadow: 24,
                bgcolor: "#f4f4f4",
                height: "130px",
                width: "100%",
                p: 2,
                boxSizing: "border-box",
              }}
            >
              <Typography
                sx={{ fontWeight: 700, fontSize: "12px", color: "#333" }}
              >
                Sorry, this service isn't available...{" "}
              </Typography>
              <Typography
                sx={{
                  fontSize: "10px",
                  fontWeight: 400,
                  lineHeight: "15px",
                  textAlign: "center",
                }}
              >
                You can't purchase any item as Mamaket services are not in your
                city
              </Typography>
              <Typography
                sx={{
                  fontSize: "10px",
                  fontWeight: 400,
                  lineHeight: "15px",
                  mt: 1,
                  color: "#333",
                }}
              >
                Do you want Mamaket services in your city?{" "}
                <Link
                  to="/contact"
                  style={{
                    color: "#2E1834",
                    fontWeight: 600,
                    textDecoration: "underline",
                  }}
                >
                  click to send us a message
                </Link>
              </Typography>
            </Box>
            <img src={not} width={150} />
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default LoginForm;
